// extracted by mini-css-extract-plugin
export default {"wrapper":"InlineInput_wrapper__2giLx","input":"InlineInput_input__seb2B","inputError":"InlineInput_inputError__lFxOY","error":"InlineInput_error__jX7fK"};